export const zoneSyncMessage = (result) => {
  if (result.success !== true) {
    return { kind: 'error', text: 'The driver app has not confirmed this sync. Check the campaign before retrying.' };
  }
  const changes = [['zones_added', 'added'], ['zones_removed', 'removed']]
    .filter(([key]) => Number.isInteger(result[key]) && result[key] >= 0)
    .map(([key, action]) => `${result[key]} zone${result[key] === 1 ? '' : 's'} ${action}`);
  const detail = changes.length ? ` Driver-reported changes: ${changes.join(', ')}.` : '';
  if (result.campaigns_updated === 0) {
    return { kind: 'warning', text: 'The driver app accepted the request, but no campaigns were updated. Confirm this advertiser’s email matches the driver campaign’s advertiser email.' + detail };
  }
  if (Number.isInteger(result.campaigns_updated) && result.campaigns_updated > 0) {
    return { kind: 'success', text: `Zones synced to ${result.campaigns_updated} campaign${result.campaigns_updated === 1 ? '' : 's'} in the driver app.` + detail };
  }
  return { kind: 'success', text: 'The driver app accepted the zone sync. Verify the campaign’s zones in the driver app.' + detail };
};

export const zoneSyncError = (result) => typeof result.detail === 'string'
  ? result.detail
  : 'The sync was not confirmed. Check the driver campaign before retrying.';